/*
 *  Created by SGiri 02/14/2018
 */

import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms'
import { Router } from '@angular/router';
import { ReportType } from '~config/model/report-type';
import { Dashboard } from '~config/model/dashbord';
import { DashboardService } from '~config/services/dashboard.service';
import { Constants } from '~util/app.constant';

@Component({
  selector: 'app-new-widget',
  templateUrl: './new-widget.component.html',
  styleUrls: ['./new-widget.component.css']
})
export class NewWidgetComponent implements OnInit {


  reportTypes: ReportType[];
  locations: string[];
  public globalDashboards: Dashboard[];

  form: FormGroup

  constructor(private service: DashboardService, private router: Router) {
    this.reportTypes = ReportType.reportTypes;
    this.locations = Constants.locations;
    this.globalDashboards = service.globalDashboards;
  }

  ngOnInit() {
    this.form = new FormGroup({
      dashboardId: new FormControl('', [Validators.required]),
      name: new FormControl('', Validators.required),
      reportPath: new FormControl('', Validators.required),
      rendererName: new FormControl('', Validators.required),
      format: new FormControl('', Validators.required),
      selection: new FormControl(),
      reportType: new FormControl('', Validators.required),
      hasInlinePrompt: new FormControl(false),
      imagePath: new FormControl('', Validators.required),
      releaseVersion: new FormControl('', Validators.required),
      drillthroughUrl: new FormControl(),
      onlinehelpUrlPageId: new FormControl(),

      location: new FormControl('L'),
      sort: new FormControl('-1'),
      userId: new FormControl({ value: '*', disabled: true }),

    })
  }

  save() {
    this.service.saveNewWidget(this.form.value).toPromise().then(() => {
      this.router.navigate(['dashboard'])
    }).catch(error => {
      console.log(error);
    });
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/new-widget/new-widget.component.ts